import axios from 'axios'; // Replace with your actual axios instance (e.g., axiosGetV2)
import { URL } from '../utils/Constants';

// Action Types
const LOAD_SHIPPING_COMPANIES = 'shippingCompanies/LOAD';
const LOAD_SHIPPING_COMPANIES_SUCCESS = 'shippingCompanies/LOAD_SUCCESS';
const LOAD_SHIPPING_COMPANIES_ERROR = 'shippingCompanies/LOAD_ERROR';

// Initial State
const initialState = {
  loading: false,
  data: [],
  error: null
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SHIPPING_COMPANIES:
      return { ...state, loading: true };
    case LOAD_SHIPPING_COMPANIES_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case LOAD_SHIPPING_COMPANIES_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

// Action Creators
export const loadShippingCompanies = () => ({
  type: LOAD_SHIPPING_COMPANIES
});

export const loadShippingCompaniesSuccess = (data) => ({
  type: LOAD_SHIPPING_COMPANIES_SUCCESS,
  payload: data
});

export const loadShippingCompaniesError = (error) => ({
  type: LOAD_SHIPPING_COMPANIES_ERROR,
  payload: error
});

// Async Action Creator (using Redux-Thunk)
export const fetchAllShippingCompanies = () => async (dispatch) => {
  dispatch(loadShippingCompanies());

  try {
    const response = await axios.get(URL.getAllShippingCompanies); // Replace with your axiosGetV2
    const companyList = response?.data?.data?.items?.map((country) => ({
      label: country.name,
      value: country.name,
      shippingMode: country.shippingMode,
      id: country?.id
    }));

    dispatch(loadShippingCompaniesSuccess(companyList));
  } catch (error) {
    dispatch(loadShippingCompaniesError(error.message));
    console.error('Failed to fetch shipping companies:', error);
  }
};

// Selectors
export const getShippingCompanies = (state) => state.shippingCompanies.data;
export const isShippingCompaniesLoading = (state) => state.shippingCompanies.loading;
export const getShippingCompaniesError = (state) => state.shippingCompanies.error;
